module.exports = __webpack_public_path__ + "static/media/principal.eef1254a.jpeg";